/*global history*/
/*eslint no-restricted-globals: ["error", "history"]*/

import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import classes from './header.css'

import AuthBtn from '../../../auth/AuthBtn'

class Header extends Component {
	render() {
		return (
			<div className={classes.Header}>
				<Link to="/consents">
					<img 
						src={require('../../../assets/logos/implantoralsurgeryLogo.png')} 
						className={classes.Logo} 
						alt="logo"
					/>
				</Link>

				<div id={classes.MenuToggle}>
					<input type="checkbox" />
					<span></span>
					<span></span>
					<span></span>
					<ul id={classes.Menu}>
						<Link className={classes.NavItem} to="/consents">
							<li>
								<i className="fa fa-file-text"></i> Consent Forms
							</li>
						</Link>
						<Link className={classes.NavItem} to="/drafts">
							<li>
								<i className="fa fa-pencil"></i> Saved Forms
							</li>
						</Link>
						<div className={classes.NavItem}>
							<AuthBtn />
						</div>
					</ul>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		consentForms: state.formBuilder.consentForms,
	}
}

export default connect(mapStateToProps)(Header)


// WEBPACK FOOTER //
// ./src/components/UI/Header/Header.js